import styles from "./signupverifyblock.module.css";
import LoginWithGoogleButton from "../LoginWithGoogleButton";
import LoginWithFacebookButton from "../LoginWithFacebookButton";
import LoginWithTiktokButton from "../LoginWithTiktokButton";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import InputOTP from "../InputOTP";
import SignupVerifyButton from "../SignupVerifyButton";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, Bounce } from "react-toastify";

export default function SignupVerifyBlock({ userId }) {
  const { t } = useTranslation();

  const [errorOTP, setErrorOTP] = useState("");
  const [OTPValue, setOTPValue] = useState("");

  return (
    <div className={styles.signupBlock}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
      <h2 className={styles.signupText}>{t("signup")}</h2>
      <div className={`col-11 ${styles.inputBlock}`}>
        <div className={`col-11 ${styles.inputContainer}`}>
          <InputOTP OTPValue={OTPValue} setOTPValue={setOTPValue} />
        </div>
        <span>{t(errorOTP)}</span>
      </div>
      <p className={styles.tosInfo}>
        {t("agreement")} <a href="terms-of-service">{t("terms")}</a> &{" "}
        <a href="privacy-policy">{t("privacy")}</a>
      </p>
      <div className={`col-12 ${styles.signupButtonContainer}`}>
        <SignupVerifyButton
          userId={userId}
          errorOTP={errorOTP}
          OTPValue={OTPValue}
          setErrorOTP={setErrorOTP}
          navigateTo={"/login"}
        />
      </div>
      {/* <div className={`col-12 ${styles.hrContainer}`}>
        <hr className={styles.leftHr} />
        <span className={styles.hrText}>{t("or")}</span>
        <hr className={styles.rightHr} />
      </div>
      <div className={`col-12 ${styles.loginWithBlock}`}>
        <div className={`col-9 ${styles.loginWithContainer}`}>
          <LoginWithGoogleButton />
        </div>
        <div className={`col-9 ${styles.loginWithContainer}`}>
          <LoginWithFacebookButton />
        </div>
        <div className={`col-9 ${styles.loginWithContainer}`}>
          <LoginWithTiktokButton />
        </div>
      </div> */}
      <p className={styles.tologinPage}>
        {t("have_account_already")} <a href="/login">{t("login")}</a>
      </p>
    </div>
  );
}
